export const PLAN_PAYMENT_TYPE = {
  REGULAR: 1,
  ONCE: 2,
}
